@if (isEnabled) {
  <div class="floating-notes-wrapper">
    <!-- Collapsed fab -->
    @if (!isOpen()) {
      <button class="notes-fab" (click)="toggle()" matTooltip="Notes" id="tour-floating-notes-fab">
        <mat-icon>sticky_note_2</mat-icon>
        @if (notes().length > 0) {
          <span class="notes-badge">{{ notes().length }}</span>
        }
      </button>
    }

    <!-- Expanded panel -->
    @if (isOpen()) {
      <div class="notes-panel">
        <div class="notes-header">
          <span class="notes-title">
            <mat-icon>sticky_note_2</mat-icon>
            Notes
          </span>
          <button mat-icon-button (click)="toggle()" class="close-btn">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <!-- Add new note -->
        <div class="add-note-row">
          <div class="color-dots">
            @for (c of colors; track c.value) {
              <button class="color-dot"
                [style.background]="c.value"
                [class.selected]="newColor === c.value"
                (click)="newColor = c.value">
              </button>
            }
          </div>
          <div class="add-input-row">
            <textarea
              class="note-input"
              [(ngModel)]="newText"
              placeholder="New note..."
              rows="2"
              (keydown.enter)="onEnter($event)">
            </textarea>
            <button mat-icon-button (click)="addNote()" [disabled]="!newText.trim()" class="add-btn">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>

        <!-- Notes list -->
        <div class="notes-list">
          @for (note of notes(); track note.id) {
            <div class="note-card" [style.background]="note.color">
              @if (editingId() === note.id) {
                <textarea class="note-edit-input" [(ngModel)]="editText" rows="3" (keydown.escape)="cancelEdit()"></textarea>
                <div class="note-edit-actions">
                  <button mat-icon-button (click)="saveEdit(note)"><mat-icon>check</mat-icon></button>
                  <button mat-icon-button (click)="cancelEdit()"><mat-icon>close</mat-icon></button>
                </div>
              } @else {
                <div class="note-text" (dblclick)="startEdit(note)">{{ note.text }}</div>
                <div class="note-actions">
                  <div class="color-dots mini">
                    @for (c of colors; track c.value) {
                      <button class="color-dot small"
                        [style.background]="c.value"
                        [class.selected]="note.color === c.value"
                        (click)="changeColor(note, c.value)">
                      </button>
                    }
                  </div>
                  <div class="note-btns">
                    <button mat-icon-button (click)="togglePin(note)" [class.pinned]="note.isPinned">
                      <mat-icon>{{ note.isPinned ? 'push_pin' : 'push_pin' }}</mat-icon>
                    </button>
                    <button mat-icon-button (click)="startEdit(note)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button (click)="deleteNote(note.id)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          @if (notes().length === 0) {
            <div class="empty-notes">No notes yet</div>
          }
        </div>
      </div>
    }
  </div>
}
